import { cn } from '@/shared/lib/cn';

interface PortalProgressProps {
  value: number;
  label: string;
  hint?: string;
  urgent?: boolean;
  className?: string;
}

export function PortalProgress({
  value,
  label,
  hint,
  urgent = false,
  className,
}: PortalProgressProps) {
  const clamped = Math.min(100, Math.max(0, value));

  return (
    <div className={cn('space-y-2', className)}>
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-sm font-medium text-foreground">{label}</span>
        {hint ? <span className="text-xs text-muted-foreground">{hint}</span> : null}
      </div>
      <div
        className="h-2.5 w-full overflow-hidden rounded-full bg-muted/80"
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
      >
        <div
          className={cn(
            'h-full rounded-full transition-all duration-500 ease-out motion-reduce:transition-none',
            urgent
              ? 'bg-gradient-to-r from-amber-500 to-amber-600'
              : 'bg-gradient-to-r from-primary to-[hsl(199_89%_48%)]',
          )}
          style={{ width: `${clamped}%` }}
        />
      </div>
    </div>
  );
}
